export enum MatomoEventCategory {
  AbcEasterEgg = "ABC easter egg",
  AbcExamPage = "ABC Exam landingpage",
  AbcGuide = "ABC Guide",
  AbcNews = "ABC News",
  AbcSettings = "ABC Settings",
  AbcWordhunt = "ABC Wordhunt",
  AbcWorkshop = "ABC Workshop",
  ArabicKeyboard = "Arabic Keyboard",
  Results = "Results",
  RussianKeyboard = "Russian Keyboard",
  Search = "Search",
  Worksheets = "Opgavehaefter"
}

export enum MatomoEventAction {
  AccessabilitySettings = "Accessability settings",
  ArabicKeyboard = "Arabic keyboard",
  ChangeLanguageDirection = "Automatic change of language direction",
  ClickAbcGuide = "Clicked guide in topbar menu",
  ClickAbcSettings = "Clicked ABC Settings",
  ClickDefinitions = "Clicked to see definitions",
  ClickExamInfoButton = "Clicked exam info button",
  ClickFuzzySuggestion = "Clicked fuzzy suggestion",
  ClickGdSettings = "Clicked GD Settings",
  ClickInflectionScheme = "Clicked to see inflection scheme",
  ClickInflectionSchemeToolNews = "Clicked inflection tool on german front page",
  ClickInflectionTool = "Clicked Inflection tool",
  ClickIrregularVerbs = "Clicked Irregular Verbs",
  ClickPhrases = "Clicked to see phrases",
  ClickPronunciation = "Clicked to hear pronunciation",
  ClickSearchbarIcons = "Clicked searchbar icons",
  ClickSpellingRules = "Clicked Spelling rules",
  ClickSynonyms = "Clicked to see synonyms",
  ClickTranslations = "Clicked to see translations",
  ClickUnfoldArticleOnFuzzy = "Clicked unfold article on fuzzy",
  ClickWordhunt = "Clicked Wordhunt",
  ClickWorksheetsButton = "Clicked worksheets button",
  DisplayedEasterEgg = "Displayed easter egg",
  ExamSettings = "Exam settings",
  FuzzyResultPageShown = "Fuzzy result page shown",
  InstitutionsSettings = "Institutions settings",
  RussianKeyboard = "Russian keyboard",
  TriggeredEasterEgg = "Triggered easter egg"
}
